import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

// Standard light-mode shell for all discovery routes.
export function MainLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default MainLayout;
